/**
 * @fileoverview React failed-message indicator for event feed messages.
 */

import React from 'react';

export interface MessageFailedProps {
  onDelete?: () => void;
  onResend?: () => void;
}

const MessageFailed: React.FC<MessageFailedProps> = ({ onDelete, onResend }) => (
  <div className="bl-message_failed">
    <div className="bl-message_failed_icon bl-icon bl-icon-notification-bell"></div>
    <span className="bl-message_failed_title">There was an error</span>
    <button className="bl-message_failed_button" onClick={onResend} type="button">
      Resend
    </button>
    <button className="bl-message_failed_button" onClick={onDelete} type="button">
      Delete
    </button>
  </div>
);

export default MessageFailed;
